/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from "prop-types";
import JobsBase from "./JobsBase";
import LocationFilter from "./LocationFilter";
import CheckboxFilter from "./CheckboxFilter";
import {filterHeadline} from "../../helpers/filters";
import './JobSearch.scss';

class JobSearch extends JobsBase {
    constructor() {
        super();
        this.state = [
            ...this.state
        ];
    }

    static propTypes = {
        title: PropTypes.string.isRequired
    };

    handleSubmit = () => {

        const params = {
            textFilter: this.state.textFilter,
            locationFilter: this.state.locationFilter,
            functionFilter: this.state.functionFilter,
            jobTypeFilter: this.state.jobTypeFilter
        };

        // Remove empty filters and nested undefined values.
        const filtered = Object.keys(params).filter(key => {
            const value = params[key];
            if (typeof value === 'object') {
                return params[key].length > 0;
            }
            return true;
        }).filter(key => params[key] != null).filter(key => params[key] !== '').reduce((acc, key) => {
            const value = params[key];
            if (typeof value === 'object') {
                return ({...acc, [key]: params[key].filter(item => item)});
            }
            return ({...acc, [key]: params[key]});
        }, {});

        // Combine params into a querystring
        const queryString = Object.keys(filtered).map(key => {
            const value = filtered[key];
            if (typeof value === 'object') {
                return value.map(item => `${key}[]=${item}`).join('&');
            }
            return `${key}=${value}`;
        }).join('&');

        // Handle Redirect
        const redirectPath = '/careers/current-openings';
        if (!queryString) {
            window.location = redirectPath;
            return;
        }

        window.location = `${redirectPath}?${queryString}`
    };

    render() {
        const {jobTypes, functions, offices} = this.getOfficesRolesAndFunctions();
        const {title} = this.props;

        return (
            <section className="jobSearch">

                <header className="jobSearch__header">
                    {title && (
                        <h3 dangerouslySetInnerHTML={{__html: filterHeadline(title)}} />
                    )}
                    <button onClick={this.clearFilters} className="jobSearch__clear"><span className="fa fa-times"/> Clear Filters</button>
                </header>

                <div className="jobSearch__textSearch">
                    <input placeholder="Keyword search" type="text" value={this.state.textFilter} onChange={e => this.handleChange(e, 'textFilter')}/>
                </div>

                <div className="jobSearch__filters">
                    <CheckboxFilter options={functions} selected={this.state.functionFilter} type="function" name="Function" handleChange={this.handleFilterChange}/>
                    <LocationFilter options={offices} selected={this.state.locationFilter} type="location" handleChange={this.handleFilterChange}/>
                    <CheckboxFilter options={jobTypes} selected={this.state.jobTypeFilter} type="jobType" name="Job Type" handleChange={this.handleFilterChange}/>
                </div>

                <div className="jobSearch__submit">
                    <button className="button button--primary" onClick={this.handleSubmit}>
                        Search
                    </button>
                </div>

            </section>
        );
    }
}

export default JobSearch;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/JobSearch.jsx